<template lang="html">
  <ResponsiveTable v-if="events && events.length > 0">
    <template v-slot:head>
      <tr>
        <th @click="sortBy('timestamp')" class="clickable-header">
          {{ $txt.timestamp }}
          <span v-if="sort_prop === 'timestamp'" class="sort-icon">{{ reverse ? '▼' : '▲' }}</span>
        </th>
        <th @click="sortBy('message')" class="clickable-header">
          {{ $txt.event_message }}
          <span v-if="sort_prop === 'message'" class="sort-icon">{{ reverse ? '▼' : '▲' }}</span>
        </th>
        <th v-if="showController" @click="sortBy('controller')" class="clickable-header">
          {{ $txt.cntrl }}
          <span v-if="sort_prop === 'controller'" class="sort-icon">{{ reverse ? '▼' : '▲' }}</span>
        </th>
        <th v-if="showZone" @click="sortBy('zone')" class="clickable-header">
          {{ $txt.zone }}
          <span v-if="sort_prop === 'zone'" class="sort-icon">{{ reverse ? '▼' : '▲' }}</span>
        </th>
        <th @click="sortBy('user')" class="clickable-header">
          User
          <span v-if="sort_prop === 'user'" class="sort-icon">{{ reverse ? '▼' : '▲' }}</span>
        </th>
        <th @click="sortBy('level')" class="clickable-header">
          {{ $txt.event_level }}
          <span v-if="sort_prop === 'level'" class="sort-icon">{{ reverse ? '▼' : '▲' }}</span>
        </th>
        <th v-if="showCode" @click="sortBy('code')" class="clickable-header">
          {{ $txt.event_code }}
          <span v-if="sort_prop === 'code'" class="sort-icon">{{ reverse ? '▼' : '▲' }}</span>
        </th>
      </tr>
    </template>
    <tbody>
      <tr v-for="(row, i) in sortedRows" :key="i" class="wm_event_log_row">
        <td class="wm_log_cell">{{ row.timestamp }}</td>
        <td class="wm_log_cell">{{ row.message }}</td>
        <td v-if="showController" class="wm_log_cell">{{ row.controller }}</td>
        <td v-if="showZone" class="wm_log_cell">{{ row.zone }}</td>
        <td class="wm_log_cell">{{ row.user }}</td>
        <td class="wm_log_cell">{{ row.level }}</td>
        <td v-if="showCode" class="wm_log_cell">{{ row.code }}</td>
      </tr>
    </tbody>
  </ResponsiveTable>
  <NoDataLabel v-else />
</template>

<script>
// Presentational event-log table matching the Events tab look.
// Takes pre-formatted event rows ({ timestamp, message, controller, zone,
// user, level, code }) and a source that controls which columns show.
// No formatting/data access here so it can be reused anywhere (e.g. the report
// event preview) without touching the shared event store.
export default {
  name: "EventLogTable",
  props: {
    events: { type: Array, default: () => [] },
    source: { type: String, default: "project" },
  },
  data() {
    return {
      sort_prop: "timestamp",
      reverse: true,
    };
  },
  computed: {
    showController() {
      return this.source === "project" || this.source === "cntrl";
    },
    showZone() {
      return this.source === "project" || this.source === "cntrl";
    },
    showCode() {
      return this.source === "project";
    },
    sortedRows() {
      const rows = [...(this.events || [])];
      const prop = this.sort_prop;
      const dir = this.reverse ? -1 : 1;
      // Stable directional sort: rows that tie on `prop` keep their incoming
      // order (the list arrives already ordered newest-first with an id
      // tiebreak), so this matches the generated report exactly.
      rows.sort((a, b) => {
        let av = a[prop];
        let bv = b[prop];
        if (av == null) av = "";
        if (bv == null) bv = "";
        if (av < bv) return -1 * dir;
        if (av > bv) return 1 * dir;
        return 0;
      });
      return rows;
    },
  },
  methods: {
    sortBy(prop) {
      if (prop === this.sort_prop) {
        this.reverse = !this.reverse;
      } else {
        this.sort_prop = prop;
        this.reverse = false;
      }
    },
  },
};
</script>

<style scoped>
.clickable-header {
  cursor: pointer;
  user-select: none;
}
.sort-icon {
  font-size: 11px;
}
.wm_log_cell {
  padding: 4px 8px;
}
</style>
